import axios from 'axios';

export default axios.create({
  // baseURL: 'http://localhost:1337/api',  
  baseURL: 'https://shark-app-uhr95.ondigitalocean.app/api',
  Headers: {
    'Authorization': 'Bearer 6608ef36e53b06855bb5f7405863c4a3626055aeb9530ef095a489f8650f98f499b10afd52e07b86808786a3e2156c5babaa501444d2a72518f70b9a221b1f4b351b9cdf02afda48d2aa4944069ae700703e6297aebced1f8e3ac5879b2a4fe69ffbf77f8aa2c4e31f6d88b3f6e5394209cb3f90a85f5ec05024215c7124b78c'
  }
});